module.exports = __webpack_public_path__ + "static/media/11.931e5f14.jpg";